<template>
  <section class="view">
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ФИО</th>
          <th class="text-left">Группа</th>
          <th class="text-left">Почта</th>
          <th class="text-left">Текст обращения</th>
          <th class="text-right"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in calls" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.group }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.text }}</td>
          <td class="text-right">
<!--
            <v-menu>
              <template v-slot:activator="{ on, attrs }" >
                <v-icon
                    class="context-menu"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>

              <v-list>
                <v-list-item @click="deleteReport(item.id)" >
                  <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
-->
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

  </section>

</template>

<script>
import {HTTP} from "../../axios";

export default {
  name: "HotlineCalls",
  data(){
    return{
      calls: [],
    }
  },
  methods:{
    update(){
      HTTP
          .get("hotline/call")
          .then(r=>{
            this.calls = r.data.reports
          })
    },
    closeAdder(){
      this.reportAdder = false
      this.update()
    },
    deleteReport(id){
      var sure = confirm("Вы уверены?")
      if(!sure){
        return false
      }

      HTTP
          .delete("hotline/call/" + id)
          .then(()=>{
            this.update()
          })
    }
  },
  mounted(){
    this.update()
  }
}
</script>

<style scoped>

</style>
